import { render } from "./CustomerPageLayout.vue?vue&type=template&id=1932600a"
import script from "./CustomerPageLayout.vue?vue&type=script&lang=js"
export * from "./CustomerPageLayout.vue?vue&type=script&lang=js"

import "./CustomerPageLayout.vue?vue&type=style&index=0&id=1932600a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__